import { createContext } from "react";

export const localizationContext = createContext(null);

export const { Provider } = localizationContext;
